export const RESET_PASSWORD_SEND_EMAIL_START_ACTION = "RESET_PASSWORD_SEND_EMAIL_START_ACTION";
export const RESET_PASSWORD_SEND_EMAIL_COMPLETE_ACTION = "RESET_PASSWORD_SEND_EMAIL_COMPLETE_ACTION";
export const RESET_PASSWORD_SEND_EMAIL_FAILED_ACTION = "RESET_PASSWORD_SEND_EMAIL_FAILED_ACTION";

export const RESET_PASSWORD_START_ACTION = "RESET_PASSWORD_START_ACTION";
export const RESET_PASSWORD_COMPLETE_ACTION = "RESET_PASSWORD_COMPLETE_ACTION";
export const RESET_PASSWORD_FAILED_ACTION = "RESET_PASSWORD_FAILED_ACTION";

export const resetPasswordSendEmail = (username, userEnteredCaptchaCode, captchaId) => {

	return (dispatch) => {

        dispatch(resetPasswordSendEmailStarted());

		let inputBody = {
			username: username,
			captcha: userEnteredCaptchaCode,
			captchaID: captchaId
		};

		return fetch("/ndapmoci/reset/request", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify(inputBody)
		})
			.then(response => {
				if (!response.ok) 
					throw Error(response.statusText);
				return response;
			})
			.then(response => response.json())
			.then(responseJson => {
                //console.log(responseJson);
                dispatch(resetPasswordSendEmailComplete(responseJson));
			})
			.catch(error => {
                console.error(error);
                dispatch(resetPasswordSendEmailFailed(error));
			});
	};
};

export const resetPasswordSendEmailStarted = () => {
    return {
        type: RESET_PASSWORD_SEND_EMAIL_START_ACTION
    }
}

export const resetPasswordSendEmailComplete = (response) => {
    return {
        type: RESET_PASSWORD_SEND_EMAIL_COMPLETE_ACTION,
        response
    };
};

export const resetPasswordSendEmailFailed = (response) => {
    return {
        type: RESET_PASSWORD_SEND_EMAIL_FAILED_ACTION,
        response
    };
};

export const resetPassword = (username, newPassword, resetCode) => {

	return (dispatch) => {

        dispatch(resetPasswordStarted());

		let inputBody = {
			username: username,
			value: newPassword,
			code: resetCode
		};

		return fetch("/ndapmoci/reset/value", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify(inputBody)
		})
			.then(response => {
				if (!response.ok) throw Error(response.statusText);
				return response;
			})
			.then(response => response.json())
			.then(responseJson => {
                dispatch(resetPasswordComplete(responseJson));
			})
			.catch(error => {
                console.error(error);
                dispatch(resetPasswordFailed(error));
			});
	};
};

export const resetPasswordStarted = () => {
    return {
        type: RESET_PASSWORD_START_ACTION
    }
}

export const resetPasswordComplete = (response) => {
    return {
        type: RESET_PASSWORD_COMPLETE_ACTION,
        response
    };
};

export const resetPasswordFailed = (response) => {
    return {
        type: RESET_PASSWORD_FAILED_ACTION,
        response
    };
};


// WEBPACK FOOTER //
// ./src/features/common/login/reset-password-form/ResetPasswordActions.jsx